import React from "react";
import { Layout } from "components/Layout/Layout";
import { PageTitle } from "components/PageMeta/PageTitle";
import { pageName } from "constants/pageNames";
import { ToolbarThinWrapper } from "components/Toolbar/ToolbarThinWrapper";
import Grid from "@mui/material/Grid2";
import { TaskListForDashboard } from "./components/TaskList";
import { TaskDashboardProvider } from "./context";

export const TaskDashboardViewer = () => {
  return (
    <TaskDashboardProvider>
      <Layout>
        <PageTitle pageName={pageName.dashboard.allTask} />
        <ToolbarThinWrapper />
        {/* <TaskSearchByReference /> */}
        <ToolbarThinWrapper />
        <Grid container spacing={1}>
          <Grid size={{ md: 6, xs: 12 }}>
            <TaskListForDashboard
              pageName={pageName.dashboard.pendingTask}
              type="pending"
            />
          </Grid>
          <Grid size={{ md: 6, xs: 12 }}>
            <TaskListForDashboard
              pageName={pageName.dashboard.acceptedTask}
              type="accepted"
            />
          </Grid>
        </Grid>
      </Layout>
    </TaskDashboardProvider>
  );
};
